/**
 * Backend tool markers are useful for tracing agent work, but they are not
 * readable conversation copy. Keep them out of user-facing summaries.
 */
export const filterToolTags = (content: string): string =>
  content
    .replace(/<tool\s+id=[^>]*>.*?<\/tool>/gs, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim()

export const getConversationPreview = (content?: string | null): string => {
  if (!content) return ""

  return filterToolTags(content).replace(/\s+/g, " ").trim()
}
